import React, { Component } from 'react'
import { Card, List, Image, Form, Input, Button, message } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';

import LinkButton from '../../components/link-button'

import storageUtils from '../../utils/storageUtils'
import { req_edit_applycase } from '../../api'

import { API_BASE } from '../../utils/contrains'
import { padLeft } from '../../utils/dataUtil'
import { formateDate } from '../../utils/dateUtil'

const Item = List.Item

export default class MyProcessCaseModify extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  


    componentDidMount() {

    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_modify_applycase = async (applycase) => {
        //console.log(applycase)
        const result = await req_edit_applycase(applycase, storageUtils.getUser().token)
        if (result.status === "success") {
            //console.log(result)
            message.success(result.message)
            this.props.history.goBack()
        } else {
            message.error(result.message)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 


    // 操作互動處理 //////////////////////////////////////////////

    onFinish = (values) => {
        //console.log('Success:', values);
        const {ProcessDescription} = values
        const { Uid, CaseNid,  MaintainerName, MaintainerEmail } = this.props.location.state.applycase
        const MaintainerCode = storageUtils.getUser().userCode
        const CaseStatus = 'REPORT_CASE'
        const condition = 'REPORTCASE'
        const applycase = {
            Uid: Uid,
            CaseNid: CaseNid,
            MaintainerCode: MaintainerCode,
            MaintainerName: MaintainerName,
            RecordDescription: ProcessDescription,
            ProcessDescription: ProcessDescription,
            CaseStatus: CaseStatus,
            condition: condition,
            operatorCode: MaintainerCode,
            operatorName: MaintainerName,
            operatorEmail: MaintainerEmail,
            operatorUnitName: MaintainerName,
        }
        this.api_modify_applycase(applycase)
    };

    /////////////////////////////////////////////////////////// 

    render() {
        const { CaseNid, CaseContent, CaseStatusName, RoomCode, ComputerCode, CreatorName, ApplyDateTime,
            RecordDescription, Appendices } = this.props.location.state.applycase

        const title = (
            <span>
                <LinkButton><ArrowLeftOutlined style={{ color: 'green', marginRight: 15, fontSize: 20 }} onClick={() => this.props.history.goBack()} /></LinkButton>
            處理回報
            </span>
        )

        return (
            <Card title={title} className='my-review-case-modify'>
                <Form
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        label="處理結果"
                        name="ProcessDescription"
                        initialValue={'已處理完成'}
                        rules={[
                            { required: true, whitespace: true, message: '必須填寫處理結果' },
                        ]}
                    >
                        <Input placeholder="輸入處理結果" />
                    </Form.Item>
                    <Form.Item>
                        <Button type='primary' htmlType="submit">確定</Button>
                    </Form.Item>
                </Form>
                <List>
                    <Item>
                        <span>
                            <span className="left">案件編號：</span>
                            <span>{'N' + padLeft(CaseNid, 7)}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">案件位置：</span>
                            <span>{RoomCode} / {ComputerCode}</span>
                        </span>
                    </Item>

                    <Item>
                        <span>
                            <span className="left">案件說明：</span>
                            <span>{CaseContent}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">附加照片：</span>
                            <span>
                                {
                                    (Appendices) ?
                                        Appendices.map(img =>
                                        (
                                            <Image
                                                key={img.FileNid}
                                                width={150}
                                                src={API_BASE + img.FileUrl}
                                                alt="" />
                                        )
                                        ) : null
                                }
                            </span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">申請時間：</span>
                            <span>{ApplyDateTime ? formateDate(ApplyDateTime) : ''}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">報案人員：</span>
                            <span>{CreatorName}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">案件備註：</span>
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: RecordDescription }} />
                            </span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">案件狀態：</span>
                            <span>{CaseStatusName}</span>
                        </span>
                    </Item>
                </List>
            </Card>
        )
    }
}
